import EditIcon from "@mui/icons-material/Edit";
import {
    Box,
    Divider,
    IconButton,
    Tooltip,
    Typography,
    styled,
    tooltipClasses,
} from "@mui/material";

import { t } from "i18next";

import { ClientPassportButton } from "../buttons/ClientPassportButton";


export const EventTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#f5f5f9",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 300,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9",
        padding: theme.spacing(1.5),
        boxShadow: theme.shadows[1],
    },
}));

function EventTime({ event }) {
    if (!event.event.extendedProps.taskObject.is_allday) {
        return (
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
                {`${t("tasks.calendar.eventTooltip.time")} `}
                {formatTime(event.event.startStr)}
            </Typography>
        );
    }
    return (
        <Typography variant="subtitle2" fontWeight="bold" mb="1">
            {t("tasks.calendar.eventTooltip.allDay")}
        </Typography>
    );
}

export function EventTooltipContent({ event, onEditClick }) {
    const { extendedProps } = event.event;
    const task = extendedProps.taskObject;

    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <EventTime event={event} />
                {onEditClick && (
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            onEditClick(e, task);
                        }}
                        size="small"
                        sx={{ ml: 1 }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
            <Divider sx={{ my: 0.5 }} />
            <Box sx={{ my: 1 }}>
                <Typography component="div" sx={{ display: "flex" }}>
                    <Box component="span" sx={{ fontWeight: "bold", minWidth: 100 }}>
                        {t("tasks.calendar.eventTooltip.title")}
                    </Box>
                    <Box component="span">{event.event.title}</Box>
                </Typography>

                <Typography component="div" sx={{ display: "flex", mt: 0.5, alignItems: "center"}}>
                    <Box component="span" sx={{ fontWeight: "bold", minWidth: 100 }}>
                        {t("tasks.calendar.eventTooltip.customerContact")}
                    </Box>
                    <Box component="span">
                        {extendedProps?.customer?.company
                            ? extendedProps?.customer?.company.name_short
                            : extendedProps?.customer 
                                ? `${extendedProps?.customer?.person.name} ${extendedProps?.customer?.person.surname}`
                                : null}
                         {extendedProps?.customer &&  <span style={{marginLeft: "5px"}}><ClientPassportButton clientId={extendedProps?.customer.id} clientType={extendedProps?.customer?.company ? "company" : "customer"}/></span>}
                    </Box>
                </Typography>

                {/* <Typography component="div" sx={{ display: "flex", mt: 0.5 }}>
                    <Box component="span" sx={{ fontWeight: "bold", minWidth: 100 }}>
                        {t("tasks.calendar.eventTooltip.seller")}
                    </Box>
                    <Box component="span">{extendedProps?.seller.full_name || "-"}</Box>
                </Typography> */}
            </Box>
            {extendedProps?.note && (
                <>
                    <Divider sx={{ my: 0.5 }} />
                    <Box sx={{ mt: 1 }}>
                        <Typography component="div" sx={{ fontWeight: "bold", mb: 0.5 }}>
                            {t("tasks.calendar.eventTooltip.note")}
                        </Typography>
                        <Typography variant="body2">{extendedProps.note}</Typography>
                    </Box>
                </>
            )}
        </Box>
    );
}

const formatTime = (dateStr) => {
    if (!dateStr) {
        return "";
    }
    const date = new Date(dateStr);
    return date.toLocaleTimeString("pl-PL", {
        hour: "2-digit",
        minute: "2-digit",
    });
};
